(() => {
  if (customElements.get('jss-feature-slider')) return;

  class JSSFeatureSlider extends HTMLElement {
    connectedCallback() {
      if (!this.classList.contains('jss-feature-bar__carousel--mobile')) return;
      this.grid = this.querySelector('.jss-feature-bar__grid');
      this.items = [...this.querySelectorAll('.jss-feature-bar__item')];
      this.previous = this.querySelector('[data-feature-previous]');
      this.next = this.querySelector('[data-feature-next]');
      this.status = this.querySelector('[data-feature-status]');
      if (!this.grid || this.items.length < 2 || !this.previous || !this.next) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.mobile = matchMedia('(max-width: 749px)');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.classList.add('is-ready');
      this.previous.addEventListener('click', () => this.move(this.index - 1), options);
      this.next.addEventListener('click', () => this.move(this.index + 1), options);
      this.grid.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.grid.addEventListener('keydown', event => {
        if (!this.mobile.matches || event.target !== this.grid) return;
        const rtl = getComputedStyle(this.grid).direction === 'rtl';
        let target;
        if (event.key === 'ArrowRight') target = this.index + (rtl ? -1 : 1);
        if (event.key === 'ArrowLeft') target = this.index + (rtl ? 1 : -1);
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = this.items.length - 1;
        if (target === undefined) return;
        event.preventDefault();
        this.move(target);
      }, options);
      this.mobile.addEventListener('change', () => this.update(), options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.items.findIndex(item => item === event.target || item.contains(event.target));
        if (index >= 0 && this.mobile.matches) this.move(index, true);
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.grid);
      this.update();
    }

    offset(item) {
      const gridRect = this.grid.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      return getComputedStyle(this.grid).direction === 'rtl'
        ? itemRect.right - gridRect.right : itemRect.left - gridRect.left;
    }

    update() {
      const mobile = this.mobile.matches;
      this.previous.hidden = this.next.hidden = !mobile;
      this.grid.tabIndex = mobile ? 0 : -1;
      this.index = this.items.reduce((closest, item, i) =>
        Math.abs(this.offset(item)) < Math.abs(this.offset(this.items[closest])) ? i : closest, 0);
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index === this.items.length - 1;
      const message = mobile ? `Feature ${this.index + 1} of ${this.items.length}` : '';
      if (this.status.textContent !== message) this.status.textContent = message;
    }

    move(index, immediate = false) {
      const item = this.items[Math.max(0, Math.min(index, this.items.length - 1))];
      this.grid.scrollBy({
        left: this.offset(item),
        behavior: immediate || this.reducedMotion.matches ? 'instant' : 'smooth'
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  }

  customElements.define('jss-feature-slider', JSSFeatureSlider);
})();
